module.exports = require("plugin-assets/shared/widget/multi-channel/utils");